const footwear = [
  {
    link: '/release-dates/',
    name: "What's hot",
    type: 'filter'
  },
  {
    link: '/release-dates/?sort=LATEST_RELEASES',
    name: 'Latest releases',
    type: 'filter'
  },
  {
    link: '/release-dates/?sort=UPCOMING_RELEASES',
    name: 'Upcoming releases',
    type: 'filter'
  },
  {
    children: [
      { link: '/release-dates/nike/', name: 'View all Nike' },
      { name: 'Air Force 1', slug: 'air-force-1', type: 'link' },
      { name: 'Air Huarache', slug: 'air-huarache', type: 'link' },
      { name: 'Air Max 1', slug: 'air-max-1', type: 'link' },
      { name: 'Air Max 90', slug: 'air-max-90', type: 'link' },
      { name: 'Air Max 95', slug: 'air-max-95', type: 'link' },
      { name: 'Air Max 97', slug: 'air-max-97', type: 'link' },
      { name: 'Blazer', slug: 'blazer', type: 'link' },
      { name: 'Dunk', slug: 'dunk', type: 'link' },
      {
        name: 'TN Air Max Plus',
        slug: 'tn-air-max-plus',
        type: 'link'
      },
      { name: 'P-6000', slug: 'p-6000', type: 'link' },
      { name: 'Shox', slug: 'shox', type: 'link' },
      { name: 'Vomero', slug: 'zoom-vomero', type: 'link' }
    ],
    icon: 'nike',
    name: 'Nike',
    path: '/release-dates/nike/',
    type: 'brand'
  },
  {
    children: [
      { link: '/release-dates/nike/jordan/', name: 'View all Jordan' },
      { name: 'Air Jordan 1', slug: 'air-jordan-1', type: 'link' },
      {
        name: 'Air Jordan 11',
        slug: 'air-jordan-11',
        type: 'link'
      },
      {
        name: 'Air Jordan 12',
        slug: 'air-jordan-12',
        type: 'link'
      },
      {
        name: 'Air Jordan 13',
        slug: 'air-jordan-13',
        type: 'link'
      },
      { name: 'Air Jordan 2', slug: 'air-jordan-2', type: 'link' },
      { name: 'Air Jordan 3', slug: 'air-jordan-3', type: 'link' },
      { name: 'Air Jordan 4', slug: 'air-jordan-4', type: 'link' },
      { name: 'Air Jordan 5', slug: 'air-jordan-5', type: 'link' },
      { name: 'Air Jordan 6', slug: 'air-jordan-6', type: 'link' },
      { name: 'Air Jordan 7', slug: 'air-jordan-7', type: 'link' },
      { name: 'Air Jordan Spizike', slug: 'air-jordan-spizike', type: 'link' }
    ],
    icon: 'jordan',
    name: 'Jordan',
    path: '/release-dates/nike/',
    type: 'brand'
  },
  {
    children: [
      { link: '/release-dates/adidas/', name: 'View all adidas' },
      { name: 'Adizero', slug: 'adizero', type: 'link' },
      { name: 'Campus', slug: 'campus', type: 'link' },
      { name: 'City Series', slug: 'city-series', type: 'link' },
      { name: 'Gazelle', slug: 'gazelle', type: 'link' },
      { name: 'NMD', slug: 'nmd', type: 'link' },
      { name: 'Samba', slug: 'samba', type: 'link' },
      { name: 'SL 72', slug: 'sl72', type: 'link' },
      { name: 'Spezial', slug: 'spezial', type: 'link' },
      { name: 'Stan Smith', slug: 'stan-smith', type: 'link' },
      { name: 'Superstar', slug: 'superstar', type: 'link' },
      { name: 'Ultraboost', slug: 'ultraboost', type: 'link' }
    ],
    icon: 'adidas',
    name: 'adidas',
    path: '/release-dates/adidas/',
    type: 'brand'
  },
  {
    children: [
      { link: '/release-dates/yeezy/', name: 'View all Yeezy' },
      { name: '450', slug: '450', type: 'link' },
      { name: '500', slug: '500', type: 'link' },
      { name: 'Boost 350', slug: 'boost-350', type: 'link' },
      { name: 'Boost 380', slug: 'boost-380', type: 'link' },
      { name: 'Boost 700', slug: 'boost-700', type: 'link' },
      { name: 'Boot', slug: 'boot', type: 'link' },
      { name: 'Foam Runner', slug: 'foam-runner', type: 'link' },
      { name: 'Quantum', slug: 'quantum', type: 'link' },
      { name: 'Slides', slug: 'slide', type: 'link' }
    ],
    icon: 'yeezy',
    name: 'Yeezy',
    path: '/release-dates/yeezy/',
    type: 'brand'
  },
  {
    children: [
      { link: '/release-dates/new-balance/', name: 'View all New balance' },
      { name: '327', slug: '327', type: 'link' },
      { name: '530', slug: '530', type: 'link' },
      { name: '550', slug: '550', type: 'link' },
      { name: '574', slug: '574', type: 'link' },
      { name: '740', slug: '740', type: 'link' },
      { name: '990', slug: '990', type: 'link' },
      { name: '991', slug: '991', type: 'link' },
      { name: '1000', slug: '1000', type: 'link' },
      { name: '9060', slug: '9060', type: 'link' },
      { name: '1906R', slug: '1906r', type: 'link' },
      { name: '2002R', slug: '2002r', type: 'link' },
      {
        name: 'Protection Pack',
        slug: 'protection-pack',
        type: 'link'
      }
    ],
    icon: 'newBalance',
    name: 'New Balance',
    path: '/release-dates/new-balance/',
    type: 'brand'
  },
  {
    children: [
      { link: '/release-dates/ugg/', name: 'View all UGGs' },
      {
        name: 'Classic Boots',
        slug: 'ultra-mini-boots',
        type: 'link'
      },
      { name: 'Goldenstar', slug: 'goldenstar', type: 'link' },
      { name: 'Lowmel', slug: 'lowmel', type: 'link' },
      { name: 'Tasman', slug: 'tasman', type: 'link' },
      { name: 'Tazz', slug: 'tazz', type: 'link' }
    ],
    icon: 'ugg',
    name: 'UGG',
    path: '/release-dates/ugg/',
    type: 'brand'
  },
  { link: '/brands/', name: 'View all brands', type: 'link' }
];

export default footwear;
